module.exports = __webpack_public_path__ + "assets/img/33_840.2b863226.jpg";